module.exports = __webpack_public_path__ + "static/media/simplonbp-bold-webfont.140609de.woff";